export class VariavelPadrao{
  id: number;
  identificador: string;
  descricao: string;
  tipo_id: string;
  tipo_certificado_id: number;
  destroy: boolean = false;
}
  


// WEBPACK FOOTER //
// ./src/app/tipos_certificados/variaveis_padroes.ts